<template>
  <EBody :style="body">
    <ESection
      :style="{
        width: '100%',
        textAlign: 'center',
        padding: '12px 0',
        backgroundColor: item.backgroundColor,
      }"
    >
      <EText
        :style="{
          margin: '0 auto',
          textAlign: 'center',
          fontSize: '12px',
          color: 'rgba(0, 0, 0, 0.7)',
          width: '100%',
        }"
      >
        Copyright © {{ item.year || "*|AÑO_ACTUAL|*" }}
        {{ item.entityName || "*|NOMBRE_EMPRESA|*" }},
        <br />
        Todos los derechos reservados
        <br />
        Nuestro correo es: {{ item.email || "*|CORREO_ELECTRÓNICO|*" }}

        <br />
        <br />

        <ELink :style="{ fontSize: '14px' }" :href="cancelHref"> Cancelar suscripción </ELink>
      </EText>
    </ESection>
  </EBody>
</template>

<script setup lang="ts">
import { EBody, ESection, EText, ELink } from "vue-email";

import { FooterItem } from "@/@types/flows/emailTemplates/items";
import { body } from "@/app/flows/emailTemplates/utils/defaultStyles";

defineProps<{ item: FooterItem }>();

const cancelHref = `https://${localStorage.getItem("workspace")}.${
  import.meta.env.VITE_HOSTNAME
}/desuscripcion`;
</script>

<style scoped lang="sass"></style>
